/**
 * Enum for transactional names. These contain things that can be bought in the game
 */
export enum TransactionalNames {
    CoinCount = 0,

    BombUpgrade,
    ClockMagnetUpgrade,
    MalwearCop,
    CountdownDestroyUpgrade,
    FruitSmasherUpgrade,
    TNTUpgrade,
    ComboChainUpgrade,
    RainbowFruitIncreaseUpgrade,
    MalwearAfro,
    NukeUpgrade,
    AddTimePerkUpgrade,
    UNUSED14,
    ScoreMultiplierUpgrade,
    UNUSED15,
    BombCount,
    ClockMagnetCount,
    SkullMagnetCount,
    NukeCount,
    FruitSmasherCount,
    MalwearBandana,
    MalwearCatMask,
    MalwearChaplin,
    MalwearClown,
    MalwearCrown,
    MalwearDevilMask,
    MalwearGirlyBow,
    MalwearGradHat,
    MalwearKarateHeadband,
    MalwearLennonGlasses,
    MalwearMardiGras,
    MalwearNoveltyGlasses,
    MalwearUFO,
    MalwearPirateMate,
    MalwearRobberMask,
    MalwearSmoresHat,
    MalwearTennisHeadband,
    MalwearTiara,
    MalwearViking,
    MalwearRobotInvaderMask,
    MalwearWindupKnightGuard,
    ElitePackUnlocked,
    CoinDoublerUnlocked,
    FacebookCoinsUsed,
    GooglePlusCoinsUsed,
    TwitterCoinsUsed,
    WindUpKnightCoinsUsed,
    UnlockAllContent,
    ForcefieldUpgrade,
    ForcefieldCount,
    ForceFieldBuyEarly,
    FruitSmasherBuyEarly,
    SkullSmasherBuyEarly,
    NukeBuyEarly,
    ClockMagnetBuyEarly,
    TokenCount,
    MalwearArrow,
    MalwearBasket,
    MalwearPanhead,
    MalwearSailor,
    MalwearScottish,
    MalwearWUK,
    MalwearBeret,
    MalwearMushroom,
    MalwearProfessional,
    MalwearSurfer,
    MalwearTiki,
    MalwearBaseball,
    MalwearLuchador,
    MalwearCowboy,
    MalwearHeadphones,
    MalwearNerdGlasses,
    AddBonusCountdownPerk,
    MushroomPopperUpgrade,
    MushroomPopperCount,
    MushroomPopperBuyEarly,
    MalwearBunny,
    MalwearLuckyHat,
    MalwearNewYears,
    MalwearValentines,
    MalwearPumpkin,
    MalwearTurkey,
    MalwearReindeer,
    MalwearFreedomHat,
    MalwearAngel,
    DesertPack,
    FreezeDropCount,
}
